<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8">
          <div class="sri-yantra" :style="cssVars">
          <div class="layer-container">
            <div v-for="item in Object.keys(layers)" :class="`layer ${item}`" :key="item">
              <inline-svg 
                :src="`${wpData.assets_path}/images/sri-yantra/${item}.svg`"
                width="100%" 
              ></inline-svg>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
          <div class="mb-3">
            <button type="button" class="btn btn-primary btn-block" @click="nextPage">Next step ></button>
            <button type="button" class="btn btn-light btn-block" @click="handleRandomColor">🎲 Random Color</button>
          </div>
         
          <div class="d-flex align-items-center mb-2" >
            <ColorPicker v-model="bgColor" /> <span class="ml-2">Background Color</span>
          </div>
          <div v-for="item in Object.keys(layers)" :key="`picker-${item}`" class="d-flex align-items-center mb-2" >
            <ColorPicker v-model="layers[item]" /> <span class="ml-2">{{item.replace('c', 'Color ')}}</span>
          </div>
      </div>
    </div>
  </div>  
</template>

<script>
import ColorPicker from '../components/ColorPicker.vue'
import InlineSvg from 'vue-inline-svg';
export default {
  components: {
    InlineSvg,
    ColorPicker,
  },
  data () {
    return {
      // eslint-disable-next-line
      wpData,
      bgColor: '#fff',
      layers: {
        c1: '#fff',
        c2: '#fff',
        c3: '#fff',
        c4: '#fff',
        c5: '#fff',
        c6: '#fff',
        c7: '#fff',
        c8: '#fff',
        c9: '#fff',
        c10: '#fff',
        c11: '#fff',
        line: '#000',
      }
    }
  },
  computed: {
    cssVars() {
      let _cssVars = {}
      _cssVars['--bg-color'] = this.bgColor
      Object.keys(this.layers).map(item => {
        _cssVars[`--${item}-color`] = this.layers[item]
      });
      return _cssVars
    }
  },
  mounted () {
    if (this.$store.state.colors) {
      this.bgColor = `${this.$store.state.colors.bgColor}`
      this.layers = {...this.$store.state.colors.layers}
    }
  },
  methods: {
    getRandomColor: function() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    handleRandomColor: function() {
      Object.keys(this.layers).map(item => {
        this.layers[item] = this.getRandomColor()
      });
      this.bgColor = this.getRandomColor()
    },
    nextPage: function() {
      this.$store.dispatch('setColors',{
        bgColor: this.bgColor,
        layers: this.layers,
      })
      this.$router.push('print')
    },
  },
}
</script>

<style lang="scss">
svg{
  width: 100%;
  height: 100%;
  
}
.layer{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  rect#border{
    stroke: none;
  }
}

.sri-yantra{
  background: var(--bg-color);
  padding: 5%;
  width: 100%;
  position: relative;
  box-shadow: 0 10px 50px rgba(0,0,0,0.15);
}
.layer-container{
  position: relative;
  width: 100%;
  padding-top: 100%;
}
.line{
  path{
    stroke: var(--line-color) !important;
  }
  polygon{
    stroke: var(--line-color) !important;
  }
}
.c1{
  polygon{
    fill: var(--c1-color) !important;
  }
}
.c2{
  polygon{
    fill: var(--c2-color) !important;
  }
}
.c3{
  polygon{
    fill: var(--c3-color) !important;
  }
}
.c4{
  polygon{
    fill: var(--c4-color) !important;
  }
}
.c5{
  polygon{
    fill: var(--c5-color) !important;
  }
}
.c6{
  path{
    fill: var(--c6-color) !important;
  }
  polygon{
    fill: var(--c6-color) !important;
  }
}
.c7{
  path{
    fill: var(--c7-color) !important;
  }
}
.c8{
  path{
    fill: var(--c8-color) !important;
  }
}
.c9{
  path{
    fill: var(--c9-color) !important;
  }
}
.c10{
  path{
    fill: var(--c10-color) !important;
  }
}
.c11{
  path{
    fill: var(--c11-color) !important;
  }
}
</style>
